module.exports = __webpack_public_path__ + "static/media/boca-photo-6.81ecc119.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/images/boca-photo-6.jpg
// module id = 2087
// module chunks = 0